// extracted by mini-css-extract-plugin
export default {"label":"WSLabel-module_label-Tqc6q","top":"WSLabel-module_top-rCKgX","link":"WSLabel-module_link-rhgZa","helperLink":"WSLabel-module_helperLink-whSUR"};